import { memoize } from "decko";

export default class Numbers {
  @memoize
  static getAverageNumber(numbers) {
    return numbers.reduce(
      (aggregator, value) => {
        return aggregator + (value / numbers.length);
      },
      0
    );
  }

  static parseFloat(value = "") {
    if (typeof value === "number") {
      return value;
    }
    if (typeof value === "string") {
      return parseFloat(value.replace(",", ".")) || 0;
    }

    return parseFloat(value);
  }
}
